import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class OracaoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  totalAdm: any = 0;
  public instituicaoFiltragem = null;
  constructor(public http: HttpClient) {

  }

  getOracoes(pag:any, meusPedidos: number, isTestemunho: string, idInstituicao: any,) {
    return this.http.get<any>(this.baseUrl + '/oracao',
      {
        observe: 'response', params:
        {
          "expand": "total, userOrei",
          "page": pag.currentPage,
          "per-page": "10",
          "meusPedidos": meusPedidos,
          "isTestemunho": isTestemunho,
          idInstituicao: idInstituicao,
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
          totalPendente: data.headers.get("X-Count-Pedido-Oracao-Pendente"),
        };

        return {
          oracoes: data.body,
          pagination: pag
        };
      }));
  }

  getAdmOracoes(pag: { currentPage: any; }, filtro: any, isTestemunho: string) {
    return this.http.post<any>(this.baseUrl + '/oracao/adm-list',
      filtro,
      {
        observe: 'response',
        params: {
          "expand": "status,liberado,privacidade,idPessoa",
          "page": pag.currentPage,
          "per-page": "5",
          'isTestemunho': isTestemunho,
        }
      }
    )
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          oracoes: data.body,
          pagination: pag
        };
      }));
  }

  oreiPorVoce(oracao: { id: any; status: boolean; }) {
    return this.http.post<any>(this.baseUrl + '/oracao/orei-por-voce', oracao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getOracao(id: any) {
    return this.http.post<any>(this.baseUrl + '/oracao/get-oracao', { id: id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  setPrivacidade(idOracao: any, privacidade: string) {
    return this.http.post<any>(this.baseUrl + '/oracao/alterar-privacidade', { idOracao: idOracao, privacidade: privacidade })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }


  getResposta(id: any) {
    return this.http.get<any>(this.baseUrl + '/oracao/resposta', {
      params: {
        'id': id
      }
    })
      .pipe(map(data => {
        if (!data.error) {
          return data.resposta;
        } else {
          return false;
        }
      }));
  }

  getAdminTotal() {
    return this.totalAdm;
  }

  getInicioOracaoAdmin() {
    return this.http.get<any>(this.baseUrl + '/oracao/get-nao-orados', {
    })
      .pipe(map(data => {
        if (!data.error) {
          this.totalAdm = data;
          return data;
        } else {
          return false;
        }
      }));
  }

  getPessoaOrando(id: any) {
    return this.http.get<any>(this.baseUrl + '/oracao/pessoas-orando', {
      params: {
        'id': id
      }
    })
      .pipe(map(data => {
        if (!data.error) {
          return data.pessoas;
        } else {
          return false;
        }
      }));
  }

  denunciar(oracao: { id: any; motivo: any; }) {
    return this.http.post<any>(this.baseUrl + '/oracao/denunciar', oracao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  excluir(id: any) {
    return this.http.post<any>(this.baseUrl + '/oracao/excluir', { id: id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  criarOracao(pedido: any, publico = false, idOracao = 0, isTestemunho = '0', idPessoa = 0) {
    return this.http.post<any>(this.baseUrl + '/oracao', { pedido: pedido, publico: publico, idOracao: idOracao, isTestemunho: isTestemunho, idPessoa: idPessoa })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  setPublico(id: any, publico: boolean) {
    return this.http.post<any>(this.baseUrl + '/oracao/set-liberado',
      { id: id, liberado: publico })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  responder(id: any, liberado: any, resposta: any) {
    return this.http.post<any>(this.baseUrl + '/oracao/enviar-resposta',
      { id: id, liberado: liberado, resposta: resposta })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  setInstituicaoFiltragem(instituicao: null) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }

  instituicaoAdmAcesso() {
    return this.http
    .get<any>(this.baseUrl + '/oracao/get-instituicao-adm-acesso')
    .pipe(map(data => {
      return data;
    }));
  }

  getInstituicoesVinculadas() {
    return this.http
      .get<any>(this.baseUrl + '/oracao/get-instituicoes-vinculadas-adm-oracao', {
        observe: 'response'
      })
      .pipe(map(data => {
        return data.body;
      }));
  }

  isConfiguracaoSede() {
    return this.http.get<any>(this.baseUrl + '/oracao/get-is-configuracao-sede').pipe(map(data => {
      return !data.error ?  data : false;
    }));
  }

}
